var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuickReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25.05 25.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.525,0A12.525,12.525,0,1,0,25.05,12.525,12.525,12.525,0,0,0,12.525,0ZM17.94,14.907H12.63c-.018,0-.035,0-.052-.005s-.034.005-.052.005a.866.866,0,0,1-.866-.866V5.2a.866.866,0,1,1,1.732,0v7.977h4.548a.866.866,0,0,1,0,1.732Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuickReport);
export default __webpack_public_path__ + "static/media/icon-quick-report.eb7dd4299f4f8da8418b96c6f8c923ff.svg";
export { ForwardRef as ReactComponent };